// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vantage -> price-brothers-vantage -> cambria-luxury-apartment-homes
// Generated: 2026-11-03T23:00:57.840Z
// Counts: 2 design, 72 content, 15 slot group, 4 collection binding, 8 section, 1 style

export const designOverrides = {
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Answers About Applying, Pets, Parking, and Maintenance</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p> Luxury Apartments on the Country Club Plaza</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Studio, One &amp; Two Bedroom Homes in Kansas City, MO</strong></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Inclusive access for every visitor</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities at Cambria Luxury Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Gated Access, Elevator, Guest Suite &amp; Everyday Conveniences</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply for <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom apartments at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Cambria Luxury Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Connect With Our Leasing Team</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1> Cambria Luxury Apartment Homes Leasing FAQs</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Studio, 1 and 2 Bedroom Apartments on the Country Club Plaza</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Nine Floor Plans in Kansas City, MO</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.lets_talk_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Your New <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span> Apartment is Waiting</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Photos of Cambria Luxury Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Take a Look Inside Our Country Club Plaza Apartments</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments Near the Country Club Plaza and UMKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore The Plaza, Midtown and Downtown Kansas City</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Live on Kansas City's Country Club Plaza</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-Friendly Apartments in Kansas City, MO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet Policies and the Pet Royalty Club at Cambria Luxury Apartment Homes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 14px;\">Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive move-in savings at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Program Benefits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for </h2><h2>Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Preferred Employers</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>How we protect your information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.grid_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Portal for Cambria Luxury Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pay Rent, Request Maintenance &amp; Manage Your Lease</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident stories from <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule a Tour of Cambria Luxury Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Visit Our Apartments in Kansas City</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Each Price Brothers Management Co. community has its own character, amenities, and floor plans. Explore the options above to find the one that feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>More communities to call home</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sister Properties</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate every page on <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "studios-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Studio Floor Plans at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We'll be in touch soon</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Take a Virtual Tour of Our Kansas City Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Cambria Luxury Apartment Homes From Anywhere</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Nine <a class=\"richtext-link\" href=\"/floor-plans\">floor plans</a> are available at Cambria Luxury Apartment Homes, spanning studio, one, and two-bedroom residences from 642 to 1,241 square feet. Private balconies and patios are available throughout the community. Select homes add hardwood floors, a kitchen pantry, or a view of the Country Club Plaza.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Cambria Luxury Apartment Homes borders the Country Club Plaza and a historic stretch of Kansas City. The address puts these apartments near The Plaza, near UMKC, and minutes from downtown Kansas City, with a Walk Score of 88 to go with it.</p><p></p><h2><strong>Getting Around Kansas City from The Plaza</strong></h2><p></p><p>Getting around from these apartments near Country Club Plaza works by bus or by car, with public transportation immediately outside the community. Lockton, Rockhurst University, and UMKC are all close by, and Saint Luke's Hospital of Kansas City sits just north of the community. Downtown Kansas City is minutes away. For longer trips, the community has access to both the US 71 and US 169 corridors, whether you are heading north, south, or across the city.</p><p></p><h2><strong>Shopping and Dining on the Country Club Plaza</strong></h2><p></p><p>The Plaza is the reason most people start looking at apartments in this part of Kansas City. Shopping, dining, and entertainment run straight through it, so the weekend tends to take care of itself. Cooper's Hawk Winery &amp; Restaurant serves New American, Brio Italian Grille covers Italian, and Fogo de Chao brings Brazilian churrasco, none of which requires leaving the neighborhood. Boutiques and storefronts line The Plaza itself, and downtown is minutes away when you want a bigger night out.</p><p></p><h2><strong>Parks, Museums and Recreation</strong><br></h2><p>The Nelson-Atkins Museum of Art is close by for an afternoon that costs nothing. Loose Park offers open green space and public tennis courts. Between those two, plus The Plaza's own architecture and its seasonal lighting displays, there is enough within a few minutes of the front door to fill most weekends.</p><p></p><h2><strong>Schools in the Area</strong></h2><p></p><p>The schools nearest Cambria Luxury Apartment Homes are Longfellow Elementary School, Central Middle School, and Central High School. Contact the applicable school district directly to confirm current attendance boundaries, enrollment requirements, and any other school information.</p><p>Residents at Cambria Luxury Apartment Homes can enjoy convenient access to schools in Kansas City, including Pembroke Hill School. Pembroke Hill serves students from early childhood through grade 12 and provides college-preparatory education with academic, arts, and athletic opportunities nearby. For future residents seeking enrollment at Pembroke Hill School, Cambria Luxury Apartment Homes offers the ideal place to call home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Minutes from Downtown, UMKC and Saint Luke's</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.employers": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>University of Kansas Medical Center</p></li><li><p>St. Luke's Hospital</p></li><li><p>Cerner</p></li><li><p>Lockton</p></li><li><p>Polsinelli</p></li><li><p>KCUMB</p></li><li><p>UMKC</p></li><li><p>CBIZ</p></li><li><p>Black and Veatch</p></li><li><p>Burns &amp; McDonnell</p></li><li><p>Burns &amp; McDonnell</p></li><li><p>KCPD</p></li><li><p>KCFD</p></li><li><p>Active Military</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Living at Cambria Luxury Apartment Homes means waking up steps from the Country Club Plaza, one of Kansas City's most recognizable destinations. From weekend brunches and boutique shopping to evening walks past the Plaza's iconic fountains, everyday life feels connected to the <a class=\"richtext-link\" href=\"/neighborhood\">neighborhood</a>. Commuters can reach UMKC, Rockhurst University, Saint Luke's Hospital, and downtown Kansas City in minutes.</p><p>Inside, <a class=\"richtext-link\" href=\"/gallery\">Tuscan-style interiors meet modern fixtures</a>: all-electric kitchens with stainless steel appliances, central air and heating, in-unit washer and dryer sets, and spacious closets. High-speed internet access, cable availability, copy and fax services, on-call emergency maintenance, and flexible rent payment options round out the community.</p>",
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "propertyoverview.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Everyday <strong>Comfort</strong>, One Block From The Plaza.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Luxury Living with Country Plaza Views.</h2>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "multihub-lead-form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "hero.rail_schedule": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "custom_self_guided_tour_url",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "contactform.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-5586-757c-8ceb-38ca48ba8909.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of Cambria Apartments building with a parking garage entrance."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "scheduletourform.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a0101d-5586-757c-8ceb-38ca48ba8909.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of Cambria Apartments building with a parking garage entrance."
      }
    }
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Living room image of an apartment at Mirabelle Luxury Apartments."
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Building exterior shot of 46 Penn Apartment Homes"
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen shot of The Dorset apartments."
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Building exterior shot of West 39th Street apartments."
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop image of Sky On Main apartments."
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Highland Park Apartment Homes leasing office sign with an arrow pointing to the right."
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Highland Park Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "10334 Goddard, Overland Park, KS 66214"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.highlandparkaptskc.com/"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167590/01a1597c-0c85-768e-871a-eb88a104c08b.webp"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.amenities": {
    "limit": 8,
    "hiddenIds": null,
    "orderedIds": [
      "ec_72cbb1dd7e84707ade4a66ec",
      "ec_0c3fe0dd134ca6be5fbae3e2",
      "ec_53029fcc4e42f3e6461823a5",
      "ec_cb43e9eacc399f14ff180251",
      "ec_1ef3623e171a8fd9f3b38f34",
      "ec_2fd3240e2cc5c34b4286ac14",
      "ec_3c6d515562fbe7cc598f5fd1",
      "ec_463a840c95f892f3252199a6",
      "ec_0f2a1a69a7e27fc1a8ed45f2",
      "ec_efefef53e983f4b71eacc165",
      "ec_09c8a9ecda3e26b0454ddd0c",
      "ec_1746ed1a712d3fabd4bd94c3",
      "ec_2d978d0c90bed6ae6a142e41",
      "ec_7eb7d7646969f700a38b1c64",
      "ec_54adbf5f24b281ae39f530a0",
      "ec_974b0319de4021d993847973",
      "ec_f467aa1c470e52ccb6756aa5",
      "ec_c4a40c988a8ed39e3bb1a507",
      "ec_4d6786c06fb962429e6eacfe",
      "ec_d3009975a703a8e6f0580669",
      "ec_9cd08fd2bd9909346a5bd6f3",
      "ec_03eb0c2103af387a4cb69735",
      "ec_581b4515f4731f8bc02e5446",
      "ec_19c800168e5851ce8ee165f7",
      "ec_ef7f5764fbdac33ee29a63b0",
      "ec_524e231ac81d6e633285cc9e",
      "ec_375cdfd18b87da7d5eb0ac4a",
      "ec_7be2edbe5dd8d95d324772ae",
      "ec_dedf56c728ee5d07c6fb5e75",
      "ec_c273ce113eded4e65b5aea5e"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": 9,
    "hiddenIds": [
      "ec_9069406b7920a917a04b2fd1",
      "custom_34bdf6a1-4ae2-4c93-a3d9-fe3c1b296077",
      "custom_8d428151-abd4-4e42-b4e4-12bd725c7780"
    ],
    "orderedIds": [
      "custom_e08e039d-d8aa-47a7-b58c-e52d521b5d6f",
      "custom_ba3e1e8e-cca2-4ea5-b92e-9136de68a0c7",
      "custom_9f3083e3-936f-48d4-88a3-a44c4ba109b7",
      "custom_c4659e1e-09e5-41fe-8a0f-79c67cb39c5a",
      "custom_ab04a765-1525-48c0-907c-b84e49b15ad1",
      "custom_d012f217-45c4-454e-8ebf-9d61bc386817",
      "custom_f162dad3-0467-4afb-a867-7c247920a060",
      "custom_90a37b1f-eebe-4843-bcaa-0391abe630c5",
      "custom_8d428151-abd4-4e42-b4e4-12bd725c7780",
      "custom_34bdf6a1-4ae2-4c93-a3d9-fe3c1b296077"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "neighborhoodsection.photos": {
    "limit": null,
    "hiddenIds": [
      "ec_9069406b7920a917a04b2fd1"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_9f3083e3-936f-48d4-88a3-a44c4ba109b7",
      "custom_34bdf6a1-4ae2-4c93-a3d9-fe3c1b296077",
      "custom_68f53455-9966-4659-8f73-c36b5371c55b",
      "custom_d1bca1c0-5e84-4e13-9003-a28486dc12cb"
    ],
    "orderedIds": [
      "custom_ab04a765-1525-48c0-907c-b84e49b15ad1",
      "custom_ba3e1e8e-cca2-4ea5-b92e-9136de68a0c7",
      "custom_e08e039d-d8aa-47a7-b58c-e52d521b5d6f",
      "custom_c4659e1e-09e5-41fe-8a0f-79c67cb39c5a",
      "custom_8d428151-abd4-4e42-b4e4-12bd725c7780",
      "custom_d012f217-45c4-454e-8ebf-9d61bc386817",
      "custom_9f3083e3-936f-48d4-88a3-a44c4ba109b7",
      "custom_f162dad3-0467-4afb-a867-7c247920a060",
      "custom_90a37b1f-eebe-4843-bcaa-0391abe630c5",
      "custom_ba9f13d9-a437-4e4d-a685-1dc65f8da4c6",
      "custom_583c6045-948d-4619-bf35-ba1d033ad5e5",
      "custom_31877173-a6db-453e-937b-53a0cf6287ef",
      "custom_e0c70af2-68d7-48a4-90a5-dfdf08cddb5b",
      "custom_04f6ce03-ea74-4b2e-8d38-0e7ce3d1daf9",
      "custom_9af8de64-56cb-4f2d-9147-7e9734baa86e",
      "custom_62a2cf7b-45db-44c2-8354-43577501666b",
      "custom_0d44d16f-bfb9-49dd-9b46-0719ff0a4d91",
      "custom_7ebf0bd1-41f2-469e-ba9f-538349320be5",
      "custom_290854bd-6963-4b63-b389-a94aace67ce7",
      "custom_d1bca1c0-5e84-4e13-9003-a28486dc12cb",
      "custom_7211d495-6c0d-4969-a131-7e5393f95548",
      "custom_65270ecd-bcac-4459-818d-179bfc357ec4",
      "custom_68f53455-9966-4659-8f73-c36b5371c55b",
      "custom_34bdf6a1-4ae2-4c93-a3d9-fe3c1b296077"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  }
};
